import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "noGate16-9" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<p class=\"click-video\"> Please click to begin the video. </p><p class=\"welcome\"> Welcome Back!<br><span class=\"sub-text d-none d-md-block\"> Click the button below to begin the video </span></p><button class=\"btn btn-white\"><i class=\"fas fa-play\"></i> Play Video </button>", 3)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("a", {
    class: "noGateClick",
    href: "javascript:void(0);",
    onClick: $setup.playVideo
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode($setup["playButton"]),
      _hoisted_2
    ])
  ]))
}